import { IRuleCondition } from "../../../../lib/types/IRuleCondition";

/**
 * Получение объекта создания ruleCondition
 */

export const getRuleConditionBody = (rules: IRuleCondition[]): string | null => {
  const result = rules
    .filter((item) => {
      const isFilled =
        item.includeList?.length ||
        item.documentTypeList?.length ||
        item.direction === "incoming" ||
        item.direction === "outgoing";
      return isFilled;
    })
    .map((item, idx) => {
      const rule: IRuleCondition = { isUniqRate: true };
      if (item.includeList?.length) {
        rule.includeList = item.includeList;
      }
      if (item.documentTypeList?.length) {
        rule.documentTypeList = item.documentTypeList;
      }
      if (item.direction === "incoming" || item.direction === "outgoing") {
        rule.direction = item.direction;
      }
      if (idx) {
        rule.relation = "OR";
      }
      return rule;
    });
  return result.length ? JSON.stringify(result) : null;
};
